import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { WhyMedufit } from '../components/WhyMedufit';
import { BodyBenefits } from '../components/BodyBenefits';
import { Ingredients } from '../components/Ingredients';
import { Compare } from '../components/Compare';
import { Benefits } from '../components/Benefits';
import { HowToUse } from '../components/HowToUse';
import { Doctors } from '../components/Doctors';
import { Reviews } from '../components/Reviews';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { PackagePicker, getPackage } from '../components/PackagePicker';
import { StickyPurchaseBar } from '../components/StickyPurchaseBar';
export function Home() {
  const [selectedPackageId, setSelectedPackageId] = useState('wellness');
  const [packageDialogOpen, setPackageDialogOpen] = useState(false);
  const selectedPackage = getPackage(selectedPackageId);
  const goToPurchase = () => {
    document.getElementById('packages')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <main className="pb-20 sm:pb-24" data-id="element-401" data-mp="2vyq9k5i0gg8t">
      <Hero selectedPackage={selectedPackage} onChangePackage={() => setPackageDialogOpen(true)} onBuyNow={goToPurchase} data-id="element-402" data-mp="2vvlugd30c03d" />
      <TrustBar data-id="element-403" data-mp="2mxs3zirxc0o4" />
      <WhyMedufit data-id="element-404" data-mp="2mw8nbr2cvnlt" />
      <div className="p-4 md:p-8 lg:p-12" data-id="element-405" data-mp="2mwqlwuchqdww">
        <BodyBenefits data-id="element-406" data-mp="2hyfh4y11ytlj" />
      </div>
      <Ingredients data-id="element-407" data-mp="2hzi5ay6zqhxr" />
      <Compare data-id="element-408" data-mp="2i009qi3t42gr" />
      <Benefits data-id="element-409" data-mp="2d775rwg5wy5q" />
      <HowToUse data-id="element-410" data-mp="2d7gttehncv8s" />
      <Doctors data-id="element-411" data-mp="2d6xhcdarmz25" />
      <Reviews data-id="element-412" data-mp="2d6fbcoyax6h1" />
      <FAQ data-id="element-413" data-mp="2d5w3y26a20h9" />
      <FinalCTA data-id="element-414" data-mp="2d548qsgle4ri" />

      <PackagePicker mode="modal" isOpen={packageDialogOpen} selectedId={selectedPackageId} onSelect={setSelectedPackageId} onClose={() => setPackageDialogOpen(false)} data-id="element-415" data-mp="28842agftyzzv" />
      <StickyPurchaseBar selectedPackage={selectedPackage} onChangePackage={() => setPackageDialogOpen(true)} onBuyNow={goToPurchase} data-id="element-416" data-mp="1z7xnmr8ebtz4" />
    </main>;
}